var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-scroller"},[_c('div',{staticClass:"container-fluid page-body-wrapper full-page-wrapper"},[_c('div',{staticClass:"content-wrapper d-flex align-items-center auth px-0"},[_c('child')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }